// extracted by mini-css-extract-plugin
module.exports = {"legend":"DataCollectorsPerformanceTableLegend_legend__3ujHM","label":"DataCollectorsPerformanceTableLegend_label__4spDk","rtl":"DataCollectorsPerformanceTableLegend_rtl__1IA_3"};